export default __webpack_public_path__ + "static/media/contact.41ba2ccc.png";